var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_521",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29232",
    "data-name": "Group 29232",
    transform: "translate(509 10673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -509, -10673)",
    filter: "url(#Ellipse_521)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_521-2",
    "data-name": "Ellipse 521",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50337",
    "data-name": "Path 50337",
    d: "M10.581,142.242l-.063,0-9.076-.567a1.006,1.006,0,0,1-.815-1.5A14.844,14.844,0,0,1,4,136.317a10.884,10.884,0,0,1,9.9-2.229,1.006,1.006,0,0,1,.648,1.42l-3.059,6.175a1.006,1.006,0,0,1-.9.559Zm0,0",
    transform: "translate(-489.482 -10782.069)",
    fill: "#ff5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50338",
    "data-name": "Path 50338",
    d: "M247.878,306.435a1.006,1.006,0,0,1-1-.943l-.566-9.076a1.006,1.006,0,0,1,.557-.964l6.175-3.059a1.006,1.006,0,0,1,1.42.648,10.883,10.883,0,0,1-2.229,9.9,14.845,14.845,0,0,1-3.861,3.37A1.006,1.006,0,0,1,247.878,306.435Zm0,0",
    transform: "translate(-719.462 -10930.437)",
    fill: "#ff193d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50339",
    "data-name": "Path 50339",
    d: "M117.12,27.282l-6.5-6.5a1.006,1.006,0,0,0-1-.253,24.645,24.645,0,0,0-10.623,6,20.421,20.421,0,0,0-1.6,1.811,24.911,24.911,0,0,0-3.628,6.529,32.885,32.885,0,0,0-1.458,5.022,30.747,30.747,0,0,0-.673,5.355,1.006,1.006,0,0,0,1.006,1.018h.012a30.691,30.691,0,0,0,5.355-.673,32.862,32.862,0,0,0,5.022-1.458,24.9,24.9,0,0,0,6.529-3.627,20.348,20.348,0,0,0,1.812-1.605,24.641,24.641,0,0,0,6-10.623A1,1,0,0,0,117.12,27.282Zm0,0",
    transform: "translate(-574.75 -10676.133)",
    fill: "#e1f1fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50340",
    "data-name": "Path 50340",
    d: "M47.526,311.8l-4.872-4.872a1.006,1.006,0,0,0-1.332-.08,9.8,9.8,0,0,0-.88.779c-3.39,3.39-3.5,8.643-3.5,8.865a1.006,1.006,0,0,0,1.006,1.019h.013c.222,0,5.475-.108,8.865-3.5a9.8,9.8,0,0,0,.779-.88,1.006,1.006,0,0,0-.08-1.332Zm0,0",
    transform: "translate(-523.581 -10943.86)",
    fill: "#fff261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50341",
    "data-name": "Path 50341",
    d: "M78.214,240.762l-2.989,2.99a1,1,0,0,0,0,1.422l7.966,7.966a1.006,1.006,0,0,0,1.422,0L87.6,250.15Zm0,0",
    transform: "translate(-559.121 -10882.228)",
    fill: "#1b3b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50342",
    "data-name": "Path 50342",
    d: "M284.039,142.386a3.068,3.068,0,1,1,2.17-.9,3.048,3.048,0,0,1-2.17.9Zm0,0",
    transform: "translate(-751.897 -10784.444)",
    fill: "#06ccab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50343",
    "data-name": "Path 50343",
    d: "M269.753,129.079a4.052,4.052,0,1,1,2.865-1.187A4.025,4.025,0,0,1,269.753,129.079Zm0-6.092a2.04,2.04,0,1,0,1.443.6A2.028,2.028,0,0,0,269.753,122.987Zm0,0",
    transform: "translate(-737.611 -10770.154)",
    fill: "#1b3b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50344",
    "data-name": "Path 50344",
    d: "M379.787.3A1,1,0,0,0,379.063,0a32.841,32.841,0,0,0-8.094,1.36l7.753,7.753a32.845,32.845,0,0,0,1.36-8.094A1,1,0,0,0,379.787.3Zm0,0",
    transform: "translate(-836.099 -10656.969)",
    fill: "#ff5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50345",
    "data-name": "Path 50345",
    d: "M121.4,78.811l-3.252-3.252L96.211,97.5a1,1,0,0,0,.711.295h.013a30.7,30.7,0,0,0,5.355-.673,32.857,32.857,0,0,0,5.022-1.458,24.9,24.9,0,0,0,6.529-3.627,20.359,20.359,0,0,0,1.811-1.605,24.64,24.64,0,0,0,6-10.623A1,1,0,0,0,121.4,78.811Zm0,0",
    transform: "translate(-579.032 -10727.661)",
    fill: "#cdebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50346",
    "data-name": "Path 50346",
    d: "M51.8,351.483l-2.436-2.436L41.516,356.9h0a1.007,1.007,0,0,0,.711.295h.013c.222,0,5.475-.108,8.865-3.5a9.768,9.768,0,0,0,.778-.88,1,1,0,0,0-.08-1.332Zm0,0",
    transform: "translate(-527.858 -10983.54)",
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50347",
    "data-name": "Path 50347",
    d: "M145.064,313.664l-3.7,3.7,3.983,3.983a1.006,1.006,0,0,0,1.422,0l2.989-2.99Zm0,0",
    transform: "translate(-621.276 -10950.436)",
    fill: "#001035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50348",
    "data-name": "Path 50348",
    d: "M299.245,150.207h0l-4.339,4.339h0a3.068,3.068,0,1,0,4.339-4.339Zm0,0",
    transform: "translate(-764.933 -10797.503)",
    fill: "#1cadb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50349",
    "data-name": "Path 50349",
    d: "M289.831,139.406l-1.422,1.422a2.04,2.04,0,0,1-2.885,2.885h0l-1.422,1.422h0a4.052,4.052,0,0,0,5.73-5.73Zm0,0",
    transform: "translate(-754.824 -10787.397)",
    fill: "#001035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50350",
    "data-name": "Path 50350",
    d: "M436.114,4.574l-4.942,4.942,3.876,3.876a32.843,32.843,0,0,0,1.36-8.094,1.006,1.006,0,0,0-.294-.724Zm0,0",
    transform: "translate(-892.425 -10661.247)",
    fill: "#ff193d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.aa956f2cb92355be588720bab4199254.svg";
export { ForwardRef as ReactComponent };